const getModalData = state => state.modal.modalData;

export default getModalData;
